import { render, staticRenderFns } from "./SliceNewsletterSignUp.vue?vue&type=template&id=4e065576&lang=pug&"
import script from "./SliceNewsletterSignUp.vue?vue&type=script&lang=js&"
export * from "./SliceNewsletterSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports